import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import ErrorBoundary from './components/ErrorBoundary';
import App from './app';

// eslint-disable-next-line no-console
console.log(`${process.env.REACT_APP_ENVIRONMENT} 👾`);

// Wrap the rendering in a function:
const render = () => {
    ReactDOM.render(
        // Wrap App inside AppContainer
        <AppContainer>
            <ErrorBoundary>
                <App />
            </ErrorBoundary>
        </AppContainer>,
        document.getElementById('root'),
    );
};

// Do this once
// registerServiceWorker();

// Render once
render();

// Webpack Hot Module Replacement API
/* if (module.hot) {
    module.hot.accept('./app', () => {
        render(App);
    });
} */
